import { Component, ComponentRef, EventEmitter, OnInit, Output } from '@angular/core';

export type Notification = {
  Type: 'info' | 'success' | 'danger' | 'error';
  Message: string;
  Body?: string;
  Count?: number;
}

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  Notification!: Notification;
  @Output() destroy = new EventEmitter();
  Ref!: ComponentRef<NotificationComponent>;
  Timeout!: NodeJS.Timeout;

  destroyNotification() {
    this.destroy.next(this.Ref);
  }
}
